<template>
  <v-row class="fill-height" justify="center"
         align="center" v-if="loadedTask && playerAvailable">
    <v-col :cols="5">
      <board :key="$route.params.id"/>
    </v-col>
    <v-col ref="rightSideWrap" v-resize="setEditorHeight" class="fill-height" :cols="7">
      <code-mirror
        :initialCode="initialCode"
        :task="task.id.toString()"
        class="ml-2 mr-2 mb-2"
        ref="cmEditor"
        v-if="editor"
        @input="onCodeChange"
        :editorHeight="editorHeight"
      />
      <div ref="belowCode">
        <em style="color: darkgray;" class="ma-0">{{$t('save_warning')}}</em>
        <control-buttons
          ref="cButtons"
          :error-show="!valid"
          :has-next-step="hasNextStep"
          :instructions_sent="instructions_sent"
          :runing="run"
          @send-instructions="sendInstructionsLocal({
            instructions: code,
            taskID: task.id,
            solution: task.solution,
            language: task.allowed,
          })"
          @reset="reset()"
          @run="runInstructions()"
          @step="nextStep()"
          @pause="pause()"
          @speed-change="changeSpeed()"
          />
        <div v-if="showControl || (task.day === 1 && task.tasknumber === 0)" class="mt-3 mb-3 ml-2 mr-2"> <!-- TODO: remove hardcoded control access -->
          <!-- Control for Playground -->
          <v-btn :disabled="instructions_sent" class="mr-2" @click="turnLeftLocal()">
            {{ $t('left') }}
          </v-btn>
          <v-btn :disabled="instructions_sent" @click="moveLocal()">
            {{ $t('move') }}
          </v-btn>
          <v-btn :disabled="instructions_sent" class="ml-2" @click="turnRightLocal()">
            {{ $t('right') }}
          </v-btn>
          <v-btn :disabled="instructions_sent" class="ml-2" @click="resetLocal()">
            {{ $t('resetLocal') }}
          </v-btn>
        </div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="ml-2 mr-2">
              <v-sheet ref="outputScrollBox" style="height: 140px; overflow-y: scroll;" class="mb-3">
                <div v-for="(logLine, i) in log" :key="i">
                  {{ logLine }}
                </div>
              </v-sheet>
              <v-alert v-if="!valid" type="error" ><pre>{{ msg }}</pre></v-alert>
            </div>
          </template>
          <span class="font-weight-bold">{{$t('prog_log')}}</span>
        </v-tooltip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CodeMirror from './CodeMirror.vue';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/darcula.css';
import { mapGetters, mapState, mapActions } from 'vuex';
import Board from './Board.vue';
import ControlButtons from './ControlButtons.vue';
export default {
  name: 'TaskView',
  props: {
    // Used to disable the editor in the text
    editor: {
      type: Boolean,
      default: true,
    },
    // Task to display
    task: {
      type: Object,
      default: null,
    },
    // Show control button (playground)
    showControl: {
      type: Boolean,
      default: false,
    },
    initialCode: {
      type: String,
      default: '',
    },
  },
  components: {
    Board,
    CodeMirror,
    ControlButtons,
  },
  methods: {
    highlightLine(number){
      /*var cm = this.$refs.cmEditor.codemirror;
      console.log("highlightLine, cm=",number,cm)
      cm.addLineClass(number, "background", "CodeMirror-hintergrund")*/
    },
    removeHighlights(){
      /*var cm = this.$refs.cmEditor.codemirror;
      for (var i=0; i<cm.doc.size; i++){
        cm.removeLineClass(i, "background", "CodeMirror-hintergrund")
      }*/
    },
    onCodeChange(newCode) {
      this.removeHighlights()
      this.code = newCode;
      this.instructions_sent = false;
      this.reset();
    },
    reset() {
      clearInterval(this.interval);
      this.run = false;
      this.resetStep();
      this.instructions_sent = false;


      this.removeHighlights()
      // this is needed for line highlighting. Otherwise the valid property doesnt reset, and the watcher below will not fire.
      this.$store.commit('game/setValid', true)
    },
    sendInstructionsLocal(obj) {
      console.log("SENDING INSTRUCTIONS. OBJ = ", obj)
      this.instructions_sent = true;
      this.sendInstructions(obj);
      this.$emit('updateCode', obj.instructions); // defined in Task.vue
    },
    createInterval() {
      this.interval = setInterval(() => {
        console.log('this', this, this.getSpeed());
        if (this.hasNextStep) {
          this.nextStep();
          //console.log(this.getCurrentLine) //get the line number of the last executed line (for testing)

          // Scroll output box to bottom
          const el = this.$refs.outputScrollBox.$el;

          if (el) {
            console.log("Scroll Element:", el);
            el.scrollTo({ top: el.scrollHeight, behaviour: 'smooth' });
          } else {
            console.warn("Scroll Element doesn't exist");
          }
        } else {
          this.run = false;
          this.pause();
        }
      }, this.getSpeed());
    },
    runInstructions() {
      this.run = true;
      this.createInterval();
    },
    pause() {
      this.run = false;
      clearInterval(this.interval);
    },
    ...mapActions('game', [
      'chooseTask', 'sendInstructions', 'shutdown',
      'nextStep', 'resetStep', 'turnRight', 'turnLeft', 'move',
    ]),
    turnLeftLocal() {
      this.turnLeft();
    },
    turnRightLocal() {
      this.turnRight();
    },
    moveLocal() {
      this.move();
    },
    resetLocal() {
      this.chooseTask({ task: this.task });
    },
    getSpeed() {
      return this.$refs.cButtons.speed;
    },
    changeSpeed() {
      if (this.run) {
        clearInterval(this.interval);
        this.createInterval();
      }
    },
    setEditorHeight() {
      // Async loading of the editor makes this tricky
      // so wait for the editor to be loaded first
      let checkRefsLoaded = (function(el) {
        return function f(resolve) {
          if(el.$refs.rightSideWrap && el.$refs.belowCode) {
            resolve();
          } else {
            setTimeout(() => {f(resolve)}, 300);
          }
        }
      })(this);
      let refsLoaded = new Promise(checkRefsLoaded);
      refsLoaded.then(() => {
        this.editorHeight = this.$refs.rightSideWrap.clientHeight - this.$refs.belowCode.clientHeight - 60;
      });
    }
  },
  computed: {
    ...mapState('tasks', ['loaded', 'tasks']),
    ...mapGetters('tasks', ['getTaskById']),
    ...mapGetters('game', ['hasNextStep', 'getCurrentLine']),
    ...mapState('game', ['log', 'msg', 'players', 'valid', 'win']),
    ...mapState('user', ['id']),
    /**
     * Check if player is available in model
     */
    playerAvailable() {
      for (const player of Object.values(this.players)) {
        if (player.uid === this.id) {
          return true;
        }
      }
      console.warn('received an request for another user???');
      return false;
    }
  },
  mounted() {
    this.code = this.initialCode;
    this.chooseTask({ task: this.task });
    this.loadedTask = true;
    this.setEditorHeight();
    console.log('Taskview loaded.');
    console.log('Player available:', this.playerAvailable, 'in list of', this.players);
  },
  watch: {
    valid(valid) {
      if (valid)
        return

      var match = this.msg.match(/ine (\d+)/)
      if (match == null){
        console.error("Could not extract line-number from error message '",this.msg+"'");
        return;
      }

      var lineNo= parseInt(match[1]) - 1
      console.log("match:", match)
      this.highlightLine(lineNo)
    }
  },
  data() {
    return {
      editorHeight: 0,
      run: false,
      instructions_sent: false,
      interval: null,
      loadedTask: false,
      code: '',
      codeEditorOptions: {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'darcula',
      },
    };
  },
};
</script>
<style>
.CodeMirror-hintergrund { background: #FF0000; }
.cm-wrap {
  height: inherit;
}
</style>
